
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class CoinManage extends Vue {}
